import {useState} from 'react';
import {useNavigate} from 'react-router';
import useListActions from 'web/modules/appearance-management/hooks/useList';
import {addCase, generateCaseNumber} from 'web/redux/actions/CaseActions';
import {fetchConditionSelection} from 'web/redux/actions/ConditionActions';
import {
  fetchCustomer,
  fetchCustomerSelection,
} from 'web/redux/actions/CustomerActions';
import {fetchRelCustomerMachineSelection} from 'web/redux/actions/RelCustomerMachineActions';

import enumList from 'web/utils/enumList';

export const useCaseApply = (
  dispatch,
  showMessage,
  setSelectedCustomerData,
) => {
  const [customerSelection, setCustomerSelection] = useState([]);
  const [conditionSelection, setConditionSelection] = useState([]);
  const [appearanceSelection, setAppearanceSelection] = useState([]);
  const [caseNumber, setCaseNumber] = useState('');
  const navigate = useNavigate();
  const {fetchAppearances} = useListActions();
  const getCustomerSelection = () => {
    dispatch(fetchCustomerSelection())
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          const customerSelection = response.payload.result;
          setCustomerSelection(customerSelection);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };
  const getConditionSelection = () => {
    dispatch(fetchConditionSelection({}))
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode && statusCode.isSuccessCode()) {
          const conditionSelectionRes = response.payload.result;
          setConditionSelection(conditionSelectionRes);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };
  const getRelCustomerMachineByCustomerCode = async (customerCode) => {
    try {
      const response = await dispatch(
        fetchRelCustomerMachineSelection({
          customerCode,
          isEnabled: true,
        }),
      );
      const statusCode = response.payload.code;
      if (statusCode && statusCode.isSuccessCode()) {
        return response.payload.result;
      } else {
        showMessage(
          enumList.messageModalMode.error,
          response.payload.code,
          response.payload.message,
        );
        return [];
      }
    } catch (error) {
      console.error('error:', error);
      return [];
    }
  };
  const handleAddCase = async ({caseData, files}) => {
    try {
      const res = await dispatch(addCase({caseData, files})).unwrap();
      const statusCode = res.code;
      if (statusCode.isSuccessCode()) {
        showMessage(enumList.messageModalMode.info, '立案成功');
      } else {
        showMessage(enumList.messageModalMode.error, res.code, res.message);
      }
    } catch (error) {
      console.error('error:', error);
    }
  };

  const handleGenerateCaseNumber = () => {
    dispatch(generateCaseNumber())
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          const caseNumber = response.payload.result;
          setCaseNumber(caseNumber.caseNumberNew);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };

  const checkCoordinatesInfo = async (customerCode) => {
    try {
      const res = await dispatch(fetchCustomer(customerCode)).unwrap();
      if (res.code.isSuccessCode()) {
        const {latitude, longitude} = res.result;
        if (!latitude || !longitude) {
          setSelectedCustomerData(res.result);
          return false;
        }
        return true;
      }
    } catch (error) {
      console.error('error:', error);
    }
  };

  const getAppearanceList = async () => {
    try {
      const res = await fetchAppearances({
        filters: {withCondition: true, flgStatus: enumList.caseFlgStatus.open},
      });
      setAppearanceSelection(res);
    } catch (error) {
      console.error(error?.response?.data);
    }
  };

  const getRelCustomerMachineSelection = async () => {
    try {
      const response = await dispatch(
        fetchRelCustomerMachineSelection({
          customerCode: formValues.customerCode,
          isEnabled: true,
        }),
      );
      const statusCode = response.payload.code;
      if (statusCode.isSuccessCode()) {
        const customerSelection = response.payload.result;
        setCustomerSelection(customerSelection);
      } else {
        console.log('not success:');
      }
    } catch (error) {
      console.error('error:', error);
    }
  };

  const goback = () => {
    navigate('/module/cases');
  };

  return {
    getCustomerSelection,
    handleAddCase,
    getConditionSelection,
    getRelCustomerMachineByCustomerCode,
    handleGenerateCaseNumber,
    setCaseNumber,
    caseNumber,
    customerSelection,
    conditionSelection,
    appearanceSelection,
    checkCoordinatesInfo,
    getAppearanceList,
    getRelCustomerMachineSelection,
    goback,
  };
};
